export const isMobileTest = (env: boolean, isMobile: string | null) =>
  env && isMobile;
